// extracted by mini-css-extract-plugin
export default {"GroupLayoutWrapper":"YSUDA_ww"};